export default __webpack_public_path__ + "static/media/Zoo_03.7f88de7b.png";